<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between pb-2">
                <h3 class="mb-0">Admin Users</h3>
                <span
                    v-if="['super_admin','sales_admin'].includes(user.role.name)"
                    class="add-button btn btn-action"
                    @click="openModal(null, 'add')"
                >
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    ADD ADMIN USER
                </span>
            </div>
            <table class="table table-responsive table-striped border-bottom">
                <thead class="thead-light">
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Role</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Quote Access</th>
                        <th>Enabled</th>
                        <th style="width: 10em"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="userInfo in allSalesReps" :key="userInfo.id">
                        <tr>
                            <td>{{ userInfo.first_name }}</td>
                            <td>{{ userInfo.last_name }}</td>
                            <td>{{ userInfo.role.display_name }}</td>
                            <td>{{ userInfo.email }}</td>
                            <td>{{ userInfo.phone }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="form-check form-switch pr-3">
                                        <input
                                            class="form-check-input cursor-pointer"
                                            type="checkbox"
                                            :id="'formSwitchChecked' + userInfo.id"
                                            :checked="userInfo.quote_access == 1"
                                            @change="
                                                updateQuoteAccess(userInfo.id, userInfo)
                                            "
                                        />
                                        <label
                                            class="form-check-label cursor-pointer"
                                            :for="'formSwitchChecked' + userInfo.id"
                                            >{{
                                                userInfo.quote_access == 1
                                                    ? "Quote Access Enabled"
                                                    : "Quote Access Disabled"
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="form-check form-switch pr-3">
                                        <input
                                            class="form-check-input cursor-pointer"
                                            type="checkbox"
                                            :id="
                                                'formSwitchCheckedEnabled' +
                                                userInfo.id
                                            "
                                            :checked="userInfo.is_disabled == 0"
                                            @change="
                                                updateAccess(userInfo.id, userInfo)
                                            "
                                        />
                                        <label
                                            class="form-check-label cursor-pointer"
                                            :for="'formSwitchChecked' + userInfo.id"
                                            >{{
                                                userInfo.is_disabled == 0
                                                    ? "User Enabled"
                                                    : "User Disabled"
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span
                                    v-if="['super_admin'].includes(user.role.name)"
                                    class="px-1 view-action"
                                    @click="openModal(userInfo, 'edit')"
                                    ><i
                                        class="fa fa-pencil"
                                        aria-hidden="true"
                                    ></i>
                                    EDIT</span
                                >
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <!-- Pagination -->
            <!-- <table-pagination
                v-model="paginatedAllSalesReps"
                :all-rows="allSalesReps"
                :perPage="perPage"
                @updateRow="updateRow">
            </table-pagination> -->
        </div>

        <!-- Add sales rep modal -->
        <b-modal
            v-model="modalShow"
            :title="modalType == 'add' ? 'ADD ADMIN USER' : 'EDIT ADMIN USER'"
            hide-footer
        >
            <SalesRepModal
                v-if="modalShow"
                :modal-data="modalData"
                :modal-type="modalType"
                @close-modal="closeModal"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore, mapGetters } from "vuex";

import TablePagination from "@/components/TablePagination.vue";
import SalesRepModal from "@/components/modals/SalesRepModal.vue";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
        SalesRepModal,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let allSalesReps = computed(function () {
            return store.state["salesRep"].allSalesReps;
        });

        function updateUserQuoteAccess(id) {
            store.dispatch("updateUserQuoteAccess", id);
        }

        function updateUserAccess(id) {
            store.dispatch("updateUserAccess", id);
        }

        onMounted(() => {
            store.dispatch("salesRep/getAllSalesReps");
        });

        return {
            user,
            allSalesReps,
            updateUserQuoteAccess,
            updateUserAccess,
        };
    },
    data() {
        return {
            paginatedAllSalesReps: [],
            perPage: 999,
            isLoading: false,
            modalShow: false,
            modalType: null,
            modalData: {},
        };
    },
    computed: {},
    mounted() {
        // FOR SUPER ADMIN OR QUOTE APPROVERS
        if (['super_admin','quote_approver','sales_reps','sales_admin'].includes(this.user.role.name)) {
            
        } else {
            this.$router.push({ name: "dashboard" });
        }
    },
    methods: {
        updateRow(val) {
            this.paginatedAllSalesReps = val;
        },
        openModal(data, val) {
            this.modalType = val;
            this.modalData = data;
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
        },
        updateQuoteAccess(userid, user) {
            user.quote_access = !user.quote_access;
            this.updateUserQuoteAccess(userid);
            window.emitter.emit("alertSuccess", {
                message: user.quote_access
                    ? "Quote is enabled successfully!"
                    : "Quote is disabled successfully!",
            });
        },
        updateAccess(userid, user) {
            user.is_disabled = !user.is_disabled;
            this.updateUserAccess(userid);
            window.emitter.emit("alertSuccess", {
                message: user.is_disabled
                    ? "User access has been disabled!"
                    : "User access has been enabled!",
            });
        },
    },
};
</script>
